import { render } from "./orders-table.vue?vue&type=template&id=3aedb766&scoped=true"
import script from "./orders-table.vue?vue&type=script&lang=ts"
export * from "./orders-table.vue?vue&type=script&lang=ts"

import "./orders-table.vue?vue&type=style&index=0&id=3aedb766&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3aedb766"

export default script